// extracted by mini-css-extract-plugin
module.exports = {"productCallout":"cn-z"};